<template>
	<div class="row-result" :class="[ isActive ? 'expanded' : '', loading ? 'loading' : '' ]">
		<div class="row-result-main" @click="select_project()">
			<div class="result-title">
				<span class="file-type" :class="project.segment.code">{{ _.upperFirst(project.segment.code) }}</span>
				<span class="title">{{ project.nom }}</span>
			</div>
			<div class="result-date"></div>
			<div class="result-infos">
				<div class="result-info hidden-temp"><icon file="edit-3" :size="16" /> {{ project.contributeurs[0] != undefined ? project.contributeurs[0].nom + " " +  project.contributeurs[0].prenom : "Pas de contributeur"}}</div>
				<div class="result-info"><icon file="user" :size="16" /> {{ project.client }}</div>
				<div class="result-info"><icon file="calendar" :size="16" /> {{ project.etudes[project.etudes.length -1].datePublication }}<span v-if="project.etudes.length >1"> / {{ project.etudes[0].datePublication }}</span>  </div>
				<div  v-if="project.relance" class="result-info bold"><icon file="check-square" :size="16" />Plan relance</div>
			</div>
			<icon class="result-loader" file="loader" :size="24" />

		</div>
		<div class="row-result-content">
			
			<div class="detail-timeline">
				<div v-for="study in project.etudes" class="timeline-item">
					<div class="timeline-study" :class="{ active: study.id == active_study.id }" @click="select_study(study)">
						<span class="timeline-study-name">{{ study.etudeType.nom }} {{ study.segment.code }}</span>
						<span class="timeline-study-date">{{ study.datePublication }}</span>
						<span class="timeline-study-arrow"></span>
					</div>
				</div>
			</div>
			<div class="detail-synthese" :class="{ nodata: !active_study.Conclusion }">
				<p class="detail-title">Synthèse et positionnement locatif du projet</p>
				<div v-if="active_study.Conclusion" class="detail-figures">
					<table class="table">
						<tr class="row-header">
							<td rowspan="2">Type</td>
							<td rowspan="2">Nb.</td>
							<td rowspan="2">Surfuce hab.</td>
							<!-- <td colspan="3"></td> -->
							<td colspan="2">Libre</td>
						</tr>
						<tr class="row-header">
							<td>Loyer (HC/HS)</td>
							<td>Loyer /m²</td>
						</tr>
						<tr>
							<td>T1</td>
							<td>3</td>
							<td>28 m²</td>
							<td>360 €</td>
							<td>12,9 €</td>
						</tr>
						<tr>
							<td>T2</td>
							<td>6</td>
							<td>46 m²</td>
							<td>540 €</td>
							<td>11,7 €</td>
						</tr>
						<tr>
							<td>T3</td>
							<td>9</td>
							<td>62 m²</td>
							<td>630 €</td>
							<td>10,2 €</td>
						</tr>
						<tr>
							<td>T4</td>
							<td>2</td>
							<td>78 m²</td>
							<td>740 €</td>
							<td>9,5 €</td>
						</tr>
						<tr class="row-footer">
							<td>Total / Moy.</td>
							<td>20</td>
							<td>54 m²</td>
							<td>574 €</td>
							<td>10,7 €</td>
						</tr>
					</table>
				</div>
				<div v-if="active_study.Conclusion" class="detail-scores">
					<div class="score">
						<p class="score-title">Dynamisme sociodémographique et attractivité du site</p>
						<div class="score-bar">
							<div class="score-bar-legend">
								<span class="score-bar-legend-value min">Faible</span>
								<span class="score-bar-legend-value max">Fort</span>
							</div>
							<div class="score-bar-progress" style="width: 75%"></div>
						</div>
					</div>
					<div class="score">
						<p class="score-title">Potentiel pour le marché locatif libre</p>
						<div class="score-bar">
							<div class="score-bar-legend">
								<span class="score-bar-legend-value min">Faible</span>
								<span class="score-bar-legend-value max">Fort</span>
							</div>
							<div class="score-bar-progress" style="width: 90%"></div>
						</div>
					</div>
					<div class="score">
						<p class="score-title">Potentiel pour le marché locatif intermédiaire</p>
						<div class="score-bar">
							<div class="score-bar-legend">
								<span class="score-bar-legend-value min">Faible</span>
								<span class="score-bar-legend-value max">Fort</span>
							</div>
							<div class="score-bar-progress" style="width: 90%"></div>
						</div>
					</div>
					<div class="score">
						<p class="score-title">Situation du marché de la promotion</p>
						<div class="score-bar">
							<div class="score-bar-legend">
								<span class="score-bar-legend-value min">Peu favorable</span>
								<span class="score-bar-legend-value max">Favorable</span>
							</div>
							<div class="score-bar-progress" style="width: 80%"></div>
						</div>
					</div>
					<div class="score">
						<p class="score-title">Valorisation patrimoniale à terme</p>
						<div class="score-bar">
							<div class="score-bar-legend">
								<span class="score-bar-legend-value min">Faible</span>
								<span class="score-bar-legend-value max">Fort</span>
							</div>
							<div class="score-bar-progress" style="width: 65%"></div>
						</div>
					</div>
					<div class="score">
						<p class="score-title">SYNTHESE GENERALE : commercialité du projet</p>
						<div class="score-bar">
							<div class="score-bar-legend">
								<span class="score-bar-legend-value min">Faible</span>
								<span class="score-bar-legend-value max">Fort</span>
							</div>
							<div class="score-bar-progress" style="width: 80%"></div>
						</div>
					</div>
				</div>
				<div v-if="active_study.Conclusion" class="detail-recommandation">
					<p><strong>Recommandation Adequation</strong></p>
					<p>Une opération qui s'inscrit un projet urbain d'envergure qui doit constituer le prolongement est du centre-ville. Le secteur Baud- Chardonnet, en plein développement, a pour objectif d'accueillir à terme 5.200 habitants mais aussi des commerces et des bureaux, dans un cadre de vie agréable à proximité de la Vilaine. Le projet étudié (îlot E) se situe sur le "parc habité" en prolongement du parc paysager en bord de la Vilaine et en bordure d'un axe structurant. Les logements pourront bénéficier d'un cadre agréable avec des vues dégagées. Cependant des nuisances sonores sont à prévoir (trafic ferroviaire sur la ligne Paris-Brest) mais elles seront atténuées par les immeubles de bureaux construits le long de la voie ferrée.</p>
					<p>De nombreuses opérations en cours de commercialisation permettront d'alimenter progressivement le marché locatif privé actuellement peu abondant sur le secteur environnant (malgré une alimentation importante ces derniers mois). Les biens récents ou neuf recensés à proximité sont valorisés autour de 10-11 €/m²/mois (hors charges et hors stationnement) pour des T2 et T3. Au regard de la situation de tension sur le marché locatif libre et sur la base de la granulométrie communiquée, un potentiel intéressant pour le développement d'une opération en locatif intermédiaire sur ce site dont la valorisation moyenne en libre pourrait être envisagée autour de 10,7 €/m² (hors charges et hors stationnement).</p>
				</div>
				<div class="detail-actions">
					<span v-if="isPdf" class="button" @click="show_study()"><span class="button-icon"><icon file="eye" /></span>Visualiser l'étude</span>
					<span class="button" @click="download_study()"><span class="button-icon"><icon file="download" /></span>Télécharger l'étude</span>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
	name: 'row-result',
	data: function() {
		return {
			loading: false
		}
	},
	props: {
		isActive: Boolean,
		project: Object
	},
	computed: {
		...mapGetters(["active_study"]),
		isPdf() {
			return this.active_study.pdfLien && this.active_study.pdfLien.indexOf("pdf") > 0;
		},
	},
	methods: {
		select_project: function() {
			this.$store.dispatch("set_last_action");
			this.$gtm.trackEvent({
				category: 'Project',
				action: 'Open',
				label: 'Project',
				value: this.project.etudes[0].nom
      		});

			this.$store.dispatch('toggle_active_project', { project: this.project });
		},
		select_study: function(study) {
			this.$store.dispatch("set_last_action");
			this.$store.dispatch('toggle_active_study', { study: study });
		},
		show_study: function() {
			this.$store.dispatch("set_last_action");
			this.$gtm.trackEvent({
				category: 'Project',
				action: "Visualiser l'étude",
				label: 'Project',
				value: this.project.name
      		});

			let self = this
				self.$store.dispatch('set_active_pdf', { active_pdf: this.active_study.pdfLien });
		},
		download_study: function() {
			let self = this
			window.open(self.active_study.pdfLien, '_blank');
			this.$gtm.trackEvent({
				category: 'Project',
				action: "Télécharger l'étude",
				label: 'Project',
				value: this.project.name
      		});
			this.$store.dispatch("set_last_action");
		}
	}
}
</script>

<style lang="stylus">
@import '../../assets/css/app'


.row-result
	border-bottom 1px solid #eee
	&:hover
		background-color lighten(red, 95%)
		.row-result-icon
			color red
			.file-type
				border-color red
				color red
		.row-result-main
			.result-title
				color red
				.checkbox
					padding 8px
	&.expanded
		background-color #f5f5f5
		background-color lighten(red, 95%)
		&:before, &:after
			content ''
			position absolute
			top -1px
			left -24px
			right -24px
			height 2px
			background-color #ddd
		&:after
			top auto
			bottom -1px
		.row-result-content
			display block
	&.loading
		.row-result-main
			.result-loader
				display block
	.row-result-main
		padding 24px
		line-height 24px
		cursor pointer
		.result-title
			font-size 1.4rem
			font-weight 500
			.file-type
				float left
		.result-infos
			height 24px
			color #999
			.result-info
				display inline-block
				margin 0 24px 0 0
				> .icon
					float left
					margin 4px 8px 0 0
			.hidden-temp
				display none !important
			.bold	
				font-weight bold
		.result-loader
			display none
			position absolute
			right 24px
			top 50%
			margin-top -12px
			animation rotate 1s infinite linear
	.row-result-content
		display none
		// min-height 500px
		// margin 16px 0 0 0
		padding 0 24px 24px 24px


.file-type
	display inline-block
	padding 0 8px
	margin 0 8px 0 0
	border-radius radius
	background-color black
	font-size 1.2rem
	color #fff
	&.LLI
		background-color orange
	&.AUT
		background-color darken(#4fa16e, 10%)
	&.GIE
		background-color #607D8B
	&.PSLA
		background-color darken(#bdcf75, 10%)
	&.LIB
		background-color blue
	&.TER
		background-color #2f4b7c
	&.RSS
		background-color darken(#f19452, 25%)
	&.LLS
		background-color purple
	&.RSE
		background-color darken(#d43d51, 10%)
	&.REL
		background-color darken(#d43d51, 30%)
	&.ACV
		background-color #ff8a80
	&.LAC
		background-color #536dfe
	&.ACC
		background-color darken(green, 30%)
	&.BRS
		background-color #64d8cb
	&.CLVG
		background-color #ff4081
	&.COPRO
		background-color darken(blue, 10%)



.detail-timeline
	height 96px
	margin 0 0 16px 0
	text-align center
	.timeline-item
		float left
		padding 0 32px 0 0
		&:last-child
			&:before
				display none
		&:before
			content ''
			position absolute
			top 50%
			left 0%
			height 2px
			width 100%
			background-color #ccc
		.timeline-study
			display block
			width 84px
			height 96px
			box-shadow 0 0 0 4px #f5f5f5
			border 2px solid #ccc
			background-color #fff
			cursor pointer
			&:last-child
				margin-right 0
			&:hover
				color red
			&.active
				// box-shadow 0 0 0 2px red
				border-color red
				color red
				&:before
					border-color red
				.timeline-study-arrow
					display block
			&:after
				content ''
				position absolute
				left -2px
				top -2px
				width: 0;
				height: 0;
				border-style: solid;
				border-width: 16px 16px 0 0;
				border-color: #f5f5f5 transparent transparent transparent;
			&:before
				content ''
				position absolute
				left -2px
				top -2px
				width: 0;
				height: 0;
				border-style: solid;
				border-width: 0 0 16px 16px;
				border-color: transparent transparent #ccc transparent;
			.timeline-study-name
				display block
				padding 24px 2px 0 2px
				font-weight 500
				font-size 1.1rem
				text-transform uppercase
				line-height 12px
			.timeline-study-date
				position absolute
				left 0
				right 0
				bottom 8px
				font-weight 500
				font-size 1.1rem
			.timeline-study-arrow
				display none
				position absolute
				left 50%
				margin-left -8px
				bottom -18px
				width 0
				height 0
				border-style solid
				border-width 0 8px 8px 8px
				border-color transparent transparent red transparent
.detail-synthese
	// margin 0 -24px
	padding 24px
	// min-height 122px
	background-color #fff
	background-color lighten(red, 98%)
	border 1px solid red
	&.nodata
		text-align center
		.detail-title, .detail-figures, .detail-scores, .detail-recommandation
			display none
		.detail-actions
			position relative
			right auto
			top auto
			.button
				@media screen and (max-width: 1660px)
					display inline-block
					margin 0 4px
				@media screen and (max-width: 1380px)
					display inline-block
					margin 0 4px
	.detail-title
		display block
		margin 0 0 16px 0
		height 16px
		line-height 16px
		text-transform uppercase
		font-weight 500
	.detail-figures
		padding 0 0 16px 0
		.table
			width auto
			max-width 100%
			border-collapse collapse
			border-spacing 0
			text-align center
			border 2px solid lighten(#333, 50%)
			background-color #fff
			tr
				&.row-header, &.row-footer
					td
						font-weight 500
						background-color lighten(#333, 95%)
				&.row-header:nth-child(2), &:nth-last-child(2)
					td
						border-bottom-color lighten(#333, 50%)
				&.row-header:first-child
					td:nth-child(-n+3)
						border-bottom-color lighten(#333, 50%)
				td
					background-clip padding-box
					padding 8px 12px
					border 1px solid #ccc
	.detail-scores
		display flex
		flex-wrap wrap
		// background-color lighten(#333, 95%)
		padding 0px 0 16px 0
		margin 0 0 16px 0
		.score
			display inline-block
			width 50%
			padding 0 8px
			margin 0 0 12px 0
			&:nth-child(2n)
				padding 0 0 0 16px
			&:nth-child(2n+1)
				padding 0 16px 0 0
			.score-title
				font-weight 500
				line-height 16px
				height 32px
				display flex
				align-items flex-end
				margin 0 0 4px 0
			.score-bar
				height 8px
				background-color lighten(red, 80%)
				// border-radius 8px
				.score-bar-legend
					position absolute
					left 0px
					right 0px
					bottom -14px
					line-height 12px
					font-size 11px
					font-weight 500
					color #ccc
					.score-bar-legend-value
						&.min
							float left
						&.max
							float right
				.score-bar-progress
					position absolute
					left 0
					top 0
					height 8px
					background red
					// border-radius 8px
					box-shadow 1px 0 0 #fff
					&:after
						content ''
						position absolute
						right 0
						top 100%
						margin-right -4px
						margin-top 1px
						width 0
						height 0
						border-style solid
						border-width 0 4px 4px 4px
						border-color transparent transparent red transparent
	.detail-recommandation
		p
			margin 0 0 8px 0
			line-height 1.4em
			&:last-child
				margin-bottom 0
	.detail-actions
		position absolute
		right 24px
		top 24px
		@media screen and (max-width: 1380px)
			position relative
			right auto
			top auto
			margin 16px 0 0 0
		.button
			display inline-block
			margin 0 0 0 8px
			padding 12px 16px
			border-radius radius
			background-color red
			color #fff
			font-weight 500
			cursor pointer
			text-align center
			@media screen and (max-width: 1660px)
				display block
				margin 0 0 8px 0
			@media screen and (max-width: 1380px)
				display inline-block
				margin 0 8px 0 0
			.button-icon
				display block
				margin-bottom 8px
			&:hover
				color #fff
				background-color darken(red, 10%)
			&:active
				color #fff
				background-color darken(red, 20%)
				transform translateY(1px)



</style>
